import { Add, ContentPaste, NoteAltOutlined, PersonOutline } from '@mui/icons-material'
import { Button, MenuItem, Tab, Tabs, TextField } from '@mui/material'
import { useLocation, useNavigate } from 'react-router'
import './Navbar.css'
import Drafts from '../OrderList/Drafts'
import { useState } from 'react'
import { ReactComponent as Logo } from './logo.svg'

export default function Navbar() {
  const navigate = useNavigate()
  const location = useLocation()

  const [draftsOpen, setDraftsOpen] = useState(false)

  return (
    <>
      <div className="navbar">
        <div className="navbar-left">
          <Logo />
          <TextField select variant="standard" label="Application" value="Order Portal">
            <MenuItem value="Order Portal" onClick={() => navigate('/order')}>
              Order Portal
            </MenuItem>
            <MenuItem
              value="Salestrack"
              onClick={() => window.open('https://salestrack.imprestechnology.com', '_blank')}
            >
              Salestrack
            </MenuItem>
          </TextField>
          <Tabs value={location.pathname.split('/')[1].toLowerCase()}>
            <Tab
              label="Order"
              icon={<ContentPaste />}
              iconPosition="start"
              value="order"
              onClick={() => {
                navigate('/order')
              }}
            />
            <Tab
              label="Rep Code"
              icon={<PersonOutline />}
              iconPosition="start"
              value="repcodes"
              onClick={() => {
                navigate('/repcodes')
              }}
            />
          </Tabs>
        </div>
        <div className="navbar-right">
          <Button variant="outlined" size="large" startIcon={<NoteAltOutlined />} onClick={() => setDraftsOpen(true)}>
            Drafts
          </Button>
          <Button
            variant="contained"
            size="large"
            startIcon={<Add />}
            onClick={() => {
              if (location.pathname === '/order/new') {
                window.location.reload()
              } else {
                navigate('/order/new')
              }
            }}
          >
            New Order
          </Button>
        </div>
      </div>
      <Drafts open={draftsOpen} onClose={() => setDraftsOpen(false)} />
    </>
  )
}
